import Laravel from '@/class/laravel'

export default class Upload extends Laravel {

    private uuid: string
    private referenceNumber: string
    private parentId?: string

    constructor(httpClient: any, uuid: string, referenceNumber: string) {

        super(httpClient)
        this.uuid = uuid
        this.referenceNumber = referenceNumber
    }

    public createAccessToken() {

        return this.createLaravelAccessToken()
    }

    public createParentFolder(parentId: string) {

        return this.httpClient.request({
                url: this.googleDriveFolder,
                method: 'post',
                headers: {
                    Authorization: `Bearer ${ this.accessToken }`
                },
                data: {
                    'parentId': parentId,
                    'referenceNumber': this.referenceNumber,
                    'uuid': this.uuid
                }
            })
            .then((response: any) => this.parentId = response.data.folderId)
    }

    public storeItem(item: any) {

        return this.httpClient.request({
            url: this.googleDriveLocation,
            method: 'post',
            headers: {
                Authorization: `Bearer ${ this.accessToken }`
            },
            data: {
                'parentId': this.parentId,
                'referenceNumber': this.referenceNumber,
                'uuid': this.uuid,
                'fileName': item.name
            }
        })
        .then(async (response: any) => await this.put(response.data[0], item))
    }

    private put(locationURL: string, item: any) {
        
        return this.httpClient.put(locationURL, item, {
            headers: {
                'Content-Type': item.type,
                'X-Upload-Content-Type': item.type
            }
        })
    }

    public getClientIds(customerCode: any, customerEmail: any, cancelToken: any, refNo: any, surveyNo: any) {
        return this.setClientIds(customerCode, customerEmail, cancelToken, refNo, surveyNo)
    }

    public storeSurveyItem(item: any, refNo: any, uploadId: any) {
        let gFileType = 'V';
        if( item.type.match('image.*') ) {
            gFileType = 'I';
        }
        this.ids.id = uploadId;
        return this.httpClient.post(this.googleUploadLocation, {
                file: {
                    name: item.name,
                    type: item.type,
                    lastModified: item.lastModified
                },
                reticIds: this.ids,
                fileType: gFileType,
                referenceNumber: refNo
            }, {
                headers: {
                    Authorization: this.apiKey
                },
                cancelToken: this.cancelToken
            })
            .then(async (locationURL: any) => {
                await this.httpClient.put(locationURL.data, item, {
                        headers: {
                            'Content-Type': item.type,
                            'X-Upload-Content-Type': item.type
                        },
                        cancelToken: this.cancelToken,
                        onUploadProgress: (progressEvent: any) => {
                        }
                    })
                    .then((response:any) => {
                    });
            })
            .catch((error: any) => {})
    }
}